export interface StatisticState {
    statisticsDictGrouping: {
        groupBy: string[],
        incomingGroupBy: string[],
        incomingGroupByOptionally: string[],
    },

    statisticGroupIncoming?: GroupIncomingItem[],

    staticGroupIncom?: any,

    statisticDetailIncoming: DetailIncomingItem[],
    statisticDetailIncomingFlag?: string,

    staticDetailIncom?: any,
    staticDetailIncomFlag?: string,

}

export class GroupIncomingFilterParams {
    date_from: string;
    date_to: string;
    group_by: string;
    partner?: string = undefined;
    service_number?: string = undefined;
    originator_operator?: string = undefined;
    service_provider?: string = undefined;
    recipient?: string = undefined;
    country?: string = undefined;
    operator?: string = undefined;
    broker_account_login?: string = undefined;
    message_direction: string;

    constructor(date_from: string, date_to: string, group_by: string) {
        this.date_from = date_from;
        this.date_to = date_to;
        this.group_by = group_by;
        this.message_direction = "mo";
    }
}

export interface GroupIncomingItem {
    date?: string,
    service_number?: string,
    partner?: string,
    originator_operator?: string,
    service_provider?: string,
    broker_account_login?: string,
    processed: number,
    error: number,
    total: number,
}

export interface GroupIncomItem {
    date?: string,
    processed: number,
    error: number,
    total: number,
}

export class DetailIncomingFilterParams {
    id?: string = undefined;
    date_from: string;
    date_to: string;
    originator?: string = undefined;
    recipient?: string = undefined;
    service_provider?: string = undefined;
    partner?: string = undefined;
    status?: string = undefined;
    error_code?: string = undefined;
    page_number: number = 1;
    broker_account_login?: string = undefined;
    message_direction: string;

    constructor(date_from: string, date_to: string) {
        this.date_from = date_from;
        this.date_to = date_to;
        this.message_direction = "mo";
    }
}

export interface DetailIncomingItem {
    id: string,
    create_date: string,
    originator: string,
    recipient: string,
    service_provider: string,
    partner: string,
    message: string,
    status: string,
    error_code?: number,
}

export class DetailIncomingItemInfo {
    id: string | null = null;
    create_date: string | null = null;
    module: string | null = null;
    service_provider: string | null = null;
    originator: string | null = null;
    operator?: string = undefined;
    country?: string = undefined;
    recipient: string | null = null;
    partner?: string = undefined;
    broker_account_login?: string = undefined;
    status: string | null = null;
    error_code?: number = undefined;
    error_description?: string = undefined;
    message: string | null = null;
}
